'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEHomeSearchInput = exports.DESearchInput = exports.SearchInput = undefined;

var _isEmpty = require('ramda/src/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _glamor = require('glamor');

var _core = require('@blueprintjs/core');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withSearchInput = require('./with-search-input');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Wrapper = _glamorous2.default.div({
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
  borderRadius: 4,
  padding: 15
}, function (_ref) {
  var isHome = _ref.isHome;
  return {
    width: isHome ? 320 : '100%'
  };
});

var StyledInputGroup = (0, _glamorous2.default)(_core.InputGroup, { filterProps: ['isRtl'] })({
  display: 'flex',
  width: '100%'
}, function (_ref2) {
  var isRtl = _ref2.isRtl;
  return {
    direction: isRtl ? 'rtl' : 'ltr'
  };
});

var isRtlClass = (0, _glamor.css)({
  '.pt-input-group .pt-input-action:last-child': {
    left: '0',
    right: 'inherit'
  },
  '.pt-input-group > .pt-icon:first-child': {
    left: 'inherit',
    right: '0'
  },
  '.pt-input-group.pt-large .pt-input': {
    paddingRight: '40px !important'
  }
});

var SearchInput = exports.SearchInput = function SearchInput(_ref3) {
  var search = _ref3.search,
      onChangeTerm = _ref3.onChangeTerm,
      onClearTerm = _ref3.onClearTerm,
      onCommitTerm = _ref3.onCommitTerm,
      isRtl = _ref3.isRtl;
  return _react2.default.createElement(StyledInputGroup, {
    isRtl: isRtl,
    value: search.term,
    onChange: onChangeTerm,
    className: (0, _classnames2.default)(_core.Classes.LARGE, _defineProperty({}, isRtlClass, isRtl)),
    leftIconName: 'search',
    rightElement: _react2.default.createElement(
      'div',
      null,
      (0, _isEmpty2.default)(search.term) ? null : _react2.default.createElement(_core.Button, {
        className: (0, _classnames2.default)(_core.Classes.MINIMAL),
        intent: _core.Intent.PRIMARY,
        iconName: 'cross',
        onClick: onClearTerm
      }),
      _react2.default.createElement(_core.Button, {
        disabled: (0, _isEmpty2.default)(search.term),
        className: (0, _classnames2.default)(_core.Classes.MINIMAL, _defineProperty({}, isRtlClass, isRtl)),
        intent: _core.Intent.PRIMARY,
        iconName: isRtl ? 'arrow-left' : 'arrow-right',
        onClick: onCommitTerm
      })
    )
  });
};

SearchInput.propTypes = {
  /*search: PropTypes.objectOf(PropTypes.shape({
    term: PropTypes.string,
  })),*/
  onChangeTerm: _propTypes2.default.func.isRequired,
  onClearTerm: _propTypes2.default.func.isRequired,
  onCommitTerm: _propTypes2.default.func.isRequired,
  isRtl: _propTypes2.default.bool
};

var DESearchInput = exports.DESearchInput = (0, _withSearchInput.withSearchInput)(SearchInput);
var DEHomeSearchInput = exports.DEHomeSearchInput = function DEHomeSearchInput(props) {
  return _react2.default.createElement(
    Wrapper,
    { isHome: true },
    _react2.default.createElement(DESearchInput, props)
  );
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-search-input/index.js
// module id = 2022
// module chunks = 0